module.exports = {
	"24": {
		"dk": {
			"name": "NHL",
			"slug": "nhl"
		}
	},
	"42": {
		"dk": {
			"name": "Champions League",
			"slug": "champions-league"
		}
	},
	"46": {
		"dk": {
			"name": "3F Superliga",
			"slug": "danish-superliga"
		}
	},
	"47": {
		"dk": {
			"name": "Premier League",
			"slug": "premier-league"
		}
	},
	"48": {
		"dk": {
			"name": "Championship",
			"slug": "championship"
		}
	},
	"50": {
		"dk": {
			"name": "EM fodbold 2020",
			"slug": "em"
		}
	},
	"51": {
		"dk": {
			"name": "Gjensidige Kvindeliga",
			"slug": "elitedivisionen"
		}
	},
	"53": {
		"dk": {
			"name": "Ligue 1",
			"slug": "ligue-1"
		}
	},
	"54": {
		"dk": {
			"name": "Bundesliga",
			"slug": "bundesliga"
		}
	},
	"55": {
		"dk": {
			"name": "Serie A",
			"slug": "serie-a"
		}
	},
	"57": {
		"dk": {
			"name": "Æresdivisionen",
			"slug": "eredivisie"
		}
	},
	"85": {
		"dk": {
			"name": "NordicBet Liga",
			"slug": "danmark-1-division"
		}
	},
	"87": {
		"dk": {
			"name": "La Liga",
			"slug": "la-liga"
		}
	},
	"132": {
		"dk": {
			"name": "FA cup",
			"slug": "fa-cup"
		}
	},
	"311": {
		"dk": {
			"name": "Danmark Metal Ligaen",
			"slug": "danmark-metal-ligaen"
		}
	},
	"9436": {
		"dk": {
			"name": "KHL",
			"slug": "khl"
		}
	},
	"9444": {
		"dk": {
			"name": "Champions Hockey League 1",
			"slug": "champions-hockey-league-1"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/config/leagues.json
// module id = 1068
// module chunks = 0 1